(() => {
  if (window.__clouduvetSlikMaskVariantGallery) return;
  window.__clouduvetSlikMaskVariantGallery = true;

  const pendingCards = new WeakMap();

  function normalizeUrl(url) {
    if (!url) return '';
    return url.startsWith('//') ? `${window.location.protocol}${url}` : url;
  }

  function updateVisibleImage(section, card) {
    if (!section || !card) return;

    const imageUrl = normalizeUrl(card.dataset.phImageSrc);
    const mediaArea = section.querySelector('.product-information__media');
    const activeSlide =
      mediaArea?.querySelector('slideshow-slide[aria-hidden="false"]') ||
      mediaArea?.querySelector('slideshow-slide');
    const image = activeSlide?.querySelector('img.product-media__image, img');

    if (!imageUrl || !image) return;

    activeSlide.querySelectorAll('picture source').forEach((source) => {
      source.srcset = imageUrl;
    });

    image.src = imageUrl;
    image.srcset = imageUrl;
    image.alt = card.dataset.phStyleLabel || image.alt;
    image.removeAttribute('data_max_resolution');
  }

  function reapplyImage(section, card) {
    updateVisibleImage(section, card);
    requestAnimationFrame(() => updateVisibleImage(section, card));
    window.setTimeout(() => updateVisibleImage(section, card), 160);
  }

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-ph-style-card]');
    const selector = card?.closest('[data-ph-style-selector]');
    const section = selector?.closest('[id^="shopify-section-"]');

    if (!card || !selector || !section) return;

    pendingCards.set(section, card);
    reapplyImage(section, card);
  });

  document.addEventListener('variant:update', (event) => {
    const section = event.target.closest?.('[id^="shopify-section-"]');
    if (!section) return;

    const variantId = String(event.detail?.resource?.id || '');
    const pendingCard = pendingCards.get(section);
    const matchingCard =
      pendingCard && String(pendingCard.dataset.phVariantId) === variantId
        ? pendingCard
        : section.querySelector(`[data-ph-style-card][data-ph-variant-id="${variantId}"]`);

    if (matchingCard) reapplyImage(section, matchingCard);
  });
})();
